import {useRequestHelper} from "@/core/helpers/request.helper";

import type {UsuarioVm} from "@/modules/usuario/type/usuario.type";
import type {
    AlterarDispositivoUsuarioSessaoCommand,
    EncerrarUsuarioSessaoCommand
} from "@/modules/usuario/commands/usuario.commands";

const requestHelper = useRequestHelper();


class UsuarioService {

    consultarInfo() {
        return requestHelper.sendRequestGet<UsuarioVm>('usuario/info');
    }

    listarUsuarioSessoes() {
        return requestHelper.sendRequestPost<any>('usuario/sessao/listar', {});
    }

    alterarDispositivo(command: AlterarDispositivoUsuarioSessaoCommand) {
        return requestHelper.sendRequestPost<object>('usuario/sessao/alterar-dispositivo', command, false);
    }

    encerrarUsuarioSessao(command: EncerrarUsuarioSessaoCommand) {
        return requestHelper.sendRequestPost<object>('usuario/sessao/encerrar', command, true);
    }


}

export default new UsuarioService();